import React from 'react';
import { Collapse } from 'antd';

/**
 * One section of the AB pulls page that opens and closes on its title.
 *
 * The page grew to five stacked cards — overview, warnings, the daily table,
 * the history — and the one somebody came for was always below the fold.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.title - The section's heading.
 * @param {boolean} [props.defaultOpen] - Open when the page loads.
 * @param {React.ReactNode} props.children - The section's content.
 * @returns {JSX.Element} The section
 */
export default function Fold({ title, defaultOpen = false, children }) {
  return (
    <Collapse
      size="small"
      defaultActiveKey={defaultOpen ? ['section'] : []}
      items={[{ key: 'section', label: title, children }]}
    />
  );
}
